import BaseRequest from './base/BaseRequest'

export default class BitfinexRequest extends BaseRequest {

  getOrderBook(symbol) {
    let url = `/bitfinex/orderbook/${symbol}`;
    return this.get(url);
  }
}
